import Select from 'react-select';
import React, { useState, useEffect } from 'react'
import ToastNotification from '../../../components/ToastNotification';
import axios from 'axios'
import * as XLSX from "xlsx";
import { saveAs } from "file-saver"; 
import { MdLocalPrintshop } from "react-icons/md";
import { FaSearch } from "react-icons/fa";


function Report_hrms() {

   const [noteType, setNoteType] = useState(null);
   const [fetchData, setfetchData] = useState([]);
   const [fromDate, setFromDate] = useState('');
   const [toDate, setToDate] = useState('');
   const [branchDetail, setBranchDetail] = useState([])
   const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
   const showToast = (msg, bg = 'success') => {
     setToast({ show: true, message: msg, bg });
   };


   const [allData, setAllData] = useState([]);
const [filteredData, setFilteredData] = useState([]);
const [selectedEmployee, setSelectedEmployee] = useState('');
 
   const reportOptions = [
     { value: 'employee_history', label: 'Employee History' },
    { value: 'employee_office', label: 'Employee Master (Office)' },
     { value: 'employee_feild', label: 'Employee Master (Feild)' },
 
   ]




const handleSearch = async (e) => {
  e.preventDefault();

  if (!noteType?.value) {
    setToast('Please select a report type', 'warning');
    return;
  }

  try {
    const params = {
      noteType: noteType.value,
       from_date: fromDate,  
      to_date: toDate
    };

    const result = await axios.get(
      'https://api.skyguard.group/api/get-hrms-report',
      { params }
    );

    const resultData = result?.data?.result || [];
   
    setfetchData(resultData);


    setAllData(resultData);     




  } catch (error) {
    console.error('❌ Error fetching report:', error);
    setToast('Error fetching report. Please try again.', 'danger');
  }
};

const employeeList = [
  ...new Map(
    allData.map(item => [
      item.emp_id,
      {
        id: item.emp_id,
        name: `${item.emp_first} ${item.emp_middle || ''} ${item.emp_last || ''}`
      }
    ])
  ).values()
];


useEffect(() => {
  if (!selectedEmployee) {
    setfetchData(allData);
  } else {
    const filtered = allData.filter(
      item => item.emp_id === Number(selectedEmployee)
    );
    setfetchData(filtered);
  }
}, [selectedEmployee, allData]);

    const handlePrint = () => {
    const content = document.getElementById("exportTable");

    if (!content) return;

    const printWindow = window.open("", "", "width=900,height=700");

    printWindow.document.write(`
  <html>
    <head>
      <title>AMC Report</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          padding: 10px;
          margin: 0;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          table-layout: auto;
          word-wrap: break-word;
        }

        th, td {
          border: 1px solid black;
          padding: 6px;
          font-size: 12px;
        }

        /* Prevent overflow */
        div {
          overflow: visible !important;
        }

        /* Fit content inside page */
        @page {
          size: A4 landscape;
          margin: 10mm;
        }
      </style>
    </head>
    <body>
      ${content.outerHTML}
    </body>
  </html>
`);
    printWindow.document.close();
    printWindow.focus();

    
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500);
  };
    
  return (
  <>
      <div className='main-section'>
           <ToastNotification
          show={toast.show}
          message={toast.message}
          bg={toast.bg}
          onClose={() => setToast({ ...toast, show: false })}
        />


          <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
              <h3 className='my-3 fw-bold fs-5 golos'> Report</h3> 

              <div className="row g-3 align-items-end">
            <div className="col-md-4">
              <label className='fw-bold'>Select Report</label>
              <Select
                options={reportOptions}
                placeholder="Choose Type ..."
                id="source"
                value={noteType}

                onChange={(selected) => {
                  setNoteType(selected);
                  setfetchData([]);
                }}
              />
            </div>

            <div className="col-md-4">
              <label className='fw-bold'>From Date</label>
              <input
                type="date"
                className="form-control"
                name="from_date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            <div className="col-md-4">
              <label className='fw-bold'>To Date</label>
              <input
                type="date"
                className="form-control"
                name="to_date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>


            <div className="col-md-12 d-flex justify-content-end align-items-end">
              {/* <button className="btn btn-primary" onClick={handleSearch} >Search</button> */}
              <FaSearch size={26} className="ms-1 text-primary"
                style={{ cursor: "pointer" }}
                title="Search"
                onClick={handleSearch}
              />

              <MdLocalPrintshop
                size={26}
                className="ms-1 text-success"
                onClick={handlePrint}
                style={{ cursor: "pointer" }}
                title="Print "
              />
            </div>
          </div>

{noteType?.value === 'employee_history' && (
  <div className="col-md-3 mb-2">
    <select
      className="form-control"
      value={selectedEmployee}
      onChange={(e) => setSelectedEmployee(e.target.value)}
    >
      <option value="">All Employees</option>
      {employeeList.map(emp => (
        <option key={emp.id} value={emp.id}>
          {emp.name}
        </option>
      ))}
    </select>
  </div>
)}

        <div id="exportTable" className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>

               {noteType?.value === 'employee_history' && (
              <table className='table table-bordered table-striped table-hover text-center align-middle'>
                <thead className='table-info'>
                  <tr>
                    <th>Suffix</th>
                    <th>Prefix</th>
                    <th>Doc Type</th>
                    <th>Effect</th>
                    <th>Date</th>
                    <th>Employee Code</th>
                    <th>Employee Name</th>
                    <th>Designation </th>
                    <th>Department</th>
                    <th>Basic</th>
                    <th>Amount</th>
                   <th> Warining Description</th>
                   <th>Sepearation Type</th>
                    
                  </tr>
                </thead>
               <tbody>
  {Array.isArray(fetchData) && fetchData.length > 0 ? (
    fetchData.map((item, idx) => {
   

      return (
        <tr key={idx}>
          <td>{item.sufix}</td>
          <td>{item.prefix}</td>
          <td>{item.doc_type} </td>
          <td>{item.effect} </td>
          <td>{item.from_date} </td>
          <td> {item.emp_code} </td>
        <td> {item.emp_first}  {item.emp_middle} {item.emp_last} </td>
        <td>{item.designation} </td>
        <td> {item.department} </td>
        <td>{item.basic} </td>
        <td>{item.amount} </td>
        <td>{item.warning_description || "-"} </td>
         <td>{item.separation_type} </td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td >No data found</td>
    </tr>
  )}
</tbody>
              </table>
            )}

   {noteType?.value === 'employee_office' && (
              <table className='table table-bordered table-striped table-hover text-center align-middle'>
                <thead className='table-info'>
                  <tr>
                    <th>Employee ID </th>
                    <th>Employee Name</th>
                    <th>Designation </th>
                    <th>Department</th>
                    <th>Basic</th>
                    <th>DOB </th>
                    <th>DOJ </th>
                     <th>Marital Status</th>
                     <th>Gender</th>
                     <th>Email</th>
                     <th>Sepearation Date</th>
                     <th>Reporting To</th>
                    <th>bank Account No</th>
                    <th>Status</th>
                  </tr>
                </thead>
               <tbody>
  {Array.isArray(fetchData) && fetchData.length > 0 ? (
    fetchData.map((item, idx) => {
   

      return (
        <tr key={idx}>
        
          <td> {item.emp_id} </td>
        <td> {item.first}  {item.middle} {item.last} </td>
        <td>{item.designation} </td>
        <td> {item.department} </td>
        <td>{item.basic} </td>
        <td>{item.dob}  </td>
        <td>{item.doj} </td>
       <td>{item.marital_status} </td>
       <td> {item.gender} </td>
       <td>{item.email} </td>
    <td>{item.separation_date} </td>
    <td>{item.reporting} </td>
<td> {item.bank_acc} </td>
<td>{item.job_status}  </td>

        </tr>
      );
    })
  ) : (
    <tr>
      <td >No data found</td>
    </tr>
  )}
</tbody>
              </table>
            )}

 {noteType?.value === 'employee_feild' && (
              <table className='table table-bordered table-striped table-hover text-center align-middle'>
                <thead className='table-info'>
                  <tr>
                    <th>Employee ID </th>
                    <th>Employee Name</th>
                    <th>Designation </th>
                    <th>Department</th>
                    <th>Basic</th>
                    <th>DOB </th>
                    <th>DOJ </th>
                     <th>Marital Status</th>
                     <th>Gender</th>
                     <th>Email</th>
                     <th>Sepearation Date</th>
                     <th>Reporting To</th>
                    <th>bank Account No</th>
                    <th>Status</th>
                  </tr>
                </thead>
               <tbody>
  {Array.isArray(fetchData) && fetchData.length > 0 ? (
    fetchData.map((item, idx) => {
   

      return (
        <tr key={idx}>
        
          <td> {item.emp_id} </td>
        <td> {item.first}  {item.middle} {item.last} </td>
        <td>{item.designation} </td>
        <td> {item.department} </td>
        <td>{item.basic} </td>
        <td>{item.dob}  </td>
        <td>{item.doj} </td>
       <td>{item.marital_status} </td>
       <td> {item.gender} </td>
       <td>{item.email} </td>
    <td>{item.separation_date} </td>
    <td>{item.reporting} </td>
<td> {item.bank_acc} </td>
<td>{item.job_status}  </td>

        </tr>
      );
    })
  ) : (
    <tr>
      <td >No data found</td>
    </tr>
  )}
</tbody>
              </table>
            )}

        </div>

          </div>
      </div>
  </>
  )
}

export default Report_hrms